import cookie from 'js-cookie'
import GLOBAL_VARIABLE from '../../constants/global-variable.enum'

class PlatformTOY {
  constructor({ npToken }) {
    this.type = 'toy'
    this.npToken = npToken
  }

  getAuthorization() {
    if (this.npToken) {
      return `Toy ${this.npToken}`
    }
  }

  getWebTokenBody() {
    return { np_token: this.npToken }
  }

  clear() {
    // 웹토큰은 PlatformTOY의 관리 키가 아니기 때문에 삭제하지 않는다.
    cookie.remove(GLOBAL_VARIABLE.WEB_SSO_SESSION_KEY, { domain: GLOBAL_VARIABLE.WEB_TOKEN_DOMAIN })
  }

  /**
   * npToken 값을 검증합니다.
   * @returns {Boolean}
   */
  isValidSession() {
    return !!this.npToken
  }
}

export default PlatformTOY